class ModelSizeGuide extends HTMLElement {
  connectedCallback() {
    const cards = Array.from(
      this.querySelectorAll("[data-model-size]")
    );
    const radios = Array.from(
      this.querySelectorAll('input[type="radio"]')
    );
    const count = this.querySelector("[data-model-size-count]");
    const empty = this.querySelector("[data-model-size-empty]");
    if (cards.length === 0 || radios.length === 0) return;
    const apply = (size) => {
      let visible = 0;
      for (const card of cards) {
        const match = size === "" || card.dataset.modelSize === size;
        card.hidden = !match;
        if (match) visible += 1;
      }
      if (count) {
        const label = visible === 1 ? count.dataset.countOne : count.dataset.countOther;
        if (label)
          count.textContent = label.replace("__COUNT__", String(visible));
      }
      if (empty) empty.hidden = visible !== 0;
    };
    for (const radio of radios) {
      radio.addEventListener("change", () => {
        if (radio.checked) apply(radio.value);
      });
    }
  }
}
if (!customElements.get("model-size-guide")) {
  customElements.define("model-size-guide", ModelSizeGuide);
}
